import React, { ReactElement } from 'react';
import ExpiredIcon from '../../icons/expired-icon';
import useStylesIconBlockExpired from './icon-block-expired.styles';

const IconBlockExpired: ReactMemoComponent = React.memo((): ReactElement => {
  const { classes } = useStylesIconBlockExpired();

  return (
    <ExpiredIcon className={classes.iconBlockExpired} />
  );
});

export default IconBlockExpired;
